import React from "react"
import { Box, Heading } from "@chakra-ui/react";
import SEO from "./SEO";

function InvesticneFondy() {
  return (
    <article>
      <SEO
        metaTitle="Investičné fondy"
        metaDesc="Kalkulačka investovania do fondov"
        name="Maxihypo.sk"
        type="article"
        author="maxihypo"
      />
      <Heading as="h1" textAlign={"center"} my={"16"}>
        Investičné fondy
      </Heading>
      <Box mt={8}>
        <Box w={"100%"} maxW={"1000px"} mx={"auto"}>
          <iframe
            src="https://www.fingo.sk/banner/investovanie/version1?inNewWindow=1&cpar=sietKalkulacka&ref=fd10ee8e373b3c1f0f615040a9b754de&utm_medium=sietKalkulacka&utm_source=879-NOCALL&affiliate=879"
            id="iframeInvestmentV1"
            title="Investičné fondy"
            style={{ minHeight: "950px", width: "100%", border: "none" }}
            className="iframes"
            loading="lazy"
          ></iframe>
        </Box>
      </Box>
    </article>
  );
}

export default InvesticneFondy
